import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { UnRx } from '@pebula/utils';

@Component({
  selector: 'sg-borrower-input',
  templateUrl: './borrower-input.component.html',
  styleUrls: ['./borrower-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    style: 'width: 100%;',
  },
  standalone: false,
})
@UnRx()
export class SgBorrowerInputComponent implements OnChanges {
  @Input() withFormControl: FormControl;
  @Input() revertTooltipMsg: string;
  @Input() errorValidatorsMessages: ValidationErrors;
  @Input() formFieldSuffix: string;
  @Input() inputSuffix: string;
  @Input() numberOfDecimalPoints: number = 0;
  @Input() get allowNegativeNumbers(): boolean {
    return this._allowNegativeNumbers;
  }
  set allowNegativeNumbers(value: BooleanInput) {
    this._allowNegativeNumbers = coerceBooleanProperty(value);
  }

  @Output() onBlurRow = new EventEmitter<void>();

  isSelected$ = new BehaviorSubject<boolean>(true);
  showRevertButton$: Observable<boolean>;

  private _allowNegativeNumbers: boolean;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('withFormControl' in changes) {
      this.showRevertButton$ = this.withFormControl?.valueChanges.pipe(
        startWith(this.withFormControl?.value),
        map((value) => value !== this.withFormControl.defaultValue)
      );
    }
  }

  onBlur(event: FocusEvent): void {
    const losingFocusParentRow = (event.target as Element)?.closest('pbl-ngrid-row');
    const receivingFocusParentRow = (event.relatedTarget as Element)?.closest('pbl-ngrid-row');
    const focusOnSameRow = losingFocusParentRow === receivingFocusParentRow;

    if (!this.withFormControl.value && !focusOnSameRow) {
      this.onBlurRow.next();
    }
    this.isSelected$.next(false);
  }

  clearInput() {
    this.isSelected$.next(true);
    if (this.withFormControl.value === this.withFormControl.defaultValue) {
      this.withFormControl.setValue(null);
    }
  }

  revertValue(): void {
    this.withFormControl.reset();
  }

  getErrorMatcher() {
    return {
      isErrorState: () => {
        return this.withFormControl.invalid && !this.isSelected$.value;
      },
    };
  }
}
